<div
    *ngIf="!link"
    class="card-header-content selenium-card-header-content"
    [ngClass]="{ 'inline-card-header': isInline }"
>
    <img [src]="posterImage" alt="{{ posterImageAlt }}" class="selenium-card-poster-image" />
    <div class="support-materials" *ngIf="hasSupportMaterials">
        <app-icon
            type="SupportMaterials"
            class="support-materials-icon selenium-card-sm-icon"
        ></app-icon>
    </div>
    <div *ngIf="duration" class="video-length selenium-card-video-length">
        {{ getFormattedDuration() }}
    </div>
</div>

<a
    [routerLink]="link"
    *ngIf="link"
    [class]="getResourcePosterClass()"
    [ngClass]="{ 'inline-card-header': isInline }"
    [attr.data-gtmlabel]="absoluteUrl"
>
    <img [src]="posterImage" alt="{{ posterImageAlt }}" />
    <div class="support-materials" *ngIf="hasSupportMaterials">
        <app-icon type="SupportMaterials" class="support-materials-icon"></app-icon>
    </div>
    <div *ngIf="duration" class="video-length">
        {{ getFormattedDuration() }}
    </div>
</a>
